export const PATHS = {
  Game: {
    PATH: "/gameTD",
  },
  HOME: {
    PATH: "/",
    LABEL: "",
    ID: 1,
    TYPE: "public",
    SUB_TYPE: "",
  },
  REF: {
    PATH: "/ref",
    LABEL: "Referral",
    ID: 17,
    TYPE: "public",
    SUB_TYPE: "",
  },
  FCD: {
    PATH: "/fcd",
    LABEL: "FCD",
    ID: 2,
    TYPE: "public",
    SUB_TYPE: "main",
  },
  MARKET: {
    PATH: "/marketplace",
    LABEL: "Marketplace",
    ID: 3,
    TYPE: "public",
    SUB_TYPE: "main",
  },
  STAKING: {
    PATH: "/staking",
    LABEL: "Staking ZTD",
    ID: 4,
    TYPE: "public",
    SUB_TYPE: "main",
  },
  STAKING_NFT: {
    PATH: "/stakingnft",
    LABEL: "Staking NFT",
    ID: 5,
    TYPE: "public",
    SUB_TYPE: "main",
  },
  NFT_BOXES: {
    NFT_BOXES_WITH_TURRETS: {
      PATH: "/nft-boxes-with-turrets",
      LABEL: "NFT Boxes with Turrets",
      ID: 6,
    },
    NFT_BOXES_WITH_COMMANDERS: {
      PATH: "/nft-boxes-with-commanders",
      LABEL: "NFT Boxes with Commanders",
      ID: 7,
    },
    NFT_BOXES_WITH_TURRETS_2: {
      PATH: "/nft-boxes-with-turrets-2",
      LABEL: "NFT Boxes with Turrets 2",
      ID: 116,
    },
    NFT_BOXES_WITH_COMMANDERS_2: {
      PATH: "/nft-boxes-with-commanders-2",
      LABEL: "NFT Boxes with Commanders 2",
      ID: 117,
    },
    TYPE: "public",
    SUB_TYPE: "main",
  },
  MINING: {
    PATH: "/mining",
    LABEL: "Mining NFT",
    ID: 8,
    TYPE: "public",
    SUB_TYPE: "main",
  },
  WHITE_PAPER: {
    LABEL: "Whitepaper",
    PATH: "https://docs.zombietd.app/",
    TYPE: "public",
    SUB_TYPE: "main",
  },
  FAQS: {
    PATH: "/faq",
    LABEL: "Faq",
    ID: 10,
    TYPE: "public",
    SUB_TYPE: "main",
  },
  TERMS_OF_USE: {
    PATH: "/terms-of-use",
    LABEL: "Terms of use",
    ID: 13,
    TYPE: "public",
    SUB_TYPE: "additional",
  },
  PRIVACY_POLICY: {
    PATH: "/privacy-policy",
    LABEL: "Privacy policy",
    ID: 14,
    TYPE: "public",
    SUB_TYPE: "additional",
  },
  ACCOUNT: {
    PATH: "/account/dashboard",
    LABEL: "Dashboard",
    ID: 11,
    TYPE: "private",
    SUB_TYPE: "account",
  },
  TRANSACTIONS: {
    PATH: "/account/transactions",
    LABEL: "Transactions",
    ID: 12,
    TYPE: "private",
    SUB_TYPE: "account",
  },
  REFERAL: {
    PATH: "/account/referrals",
    LABEL: "Referrals",
    ID: 15,
    TYPE: "private",
    SUB_TYPE: "account",
  },
  TOURNAMENTS: {
    PATH: "/tournaments",
    LABEL: "Tournaments",
    ID: 16,
    TYPE: "public",
    SUB_TYPE: "main",
  },
  TOURNAMENT_DETAILS: {
    PATH: "/tournaments/",
    ROUTE: "/tournaments/:id",
    LABEL: "Tournament details",
    ID: 17,
    TYPE: "public",
    SUB_TYPE: "additional",
  },
  TOURNAMENTS_HISTORY: {
    PATH: "/tournaments/history",
    LABEL: "Tournaments history",
    ID: 18,
    TYPE: "public",
    SUB_TYPE: "additional",
  },
}
